import type {
  AllMembersPerformanceIndicatorItem,
  AllMembersPerformanceItem,
  AllMembersPerformanceQueryCondition,
  AllMembersPerformanceUpdateCoefParams,
} from './types'

import type { PagingRequest } from '#/api/type'

import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'

function normalizeIndicators(indicators: AllMembersPerformanceIndicatorItem[]) {
  return (
    indicators?.map((indicator) => ({
      completion: Number(indicator.completion ?? 0),
      currentValue: Number(indicator.currentValue ?? 0),
      indicatorId: indicator.indicatorId ?? '',
      indicatorName: indicator.indicatorName || '-',
      progressDeviation: Number(indicator.progressDeviation ?? 0),
      targetValue: Number(indicator.targetValue ?? 0),
      weight: Number(indicator.weight ?? 0),
    })) || []
  )
}

function normalizePerformanceItem(item: AllMembersPerformanceItem) {
  const indicators = normalizeIndicators(item.indicators || [])
  return {
    estimatedCoef: Number(item.estimatedCoef ?? 0),
    finalCoef:
      item.finalCoef === null || item.finalCoef === undefined
        ? null
        : Number(item.finalCoef),
    id: item.id ?? '',
    indicators,
    indicatorsValue: indicators.map((item) => item.indicatorName).join('/'),
    isFinished: Number(item.isFinished ?? 0),
    quarter: item.quarter || '',
    userOpenId: item.userOpenId || '',
  }
}

export const allMembersPerformanceApi = defineApi('operation', ({ prefix }) => {
  /**
   * 全员绩效列表
   * POST /gobestads/operation/adsPerformance/result/query
   */
  function getAllMembersPerformancePage(
    params: PagingRequest<AllMembersPerformanceQueryCondition>,
  ) {
    return requestClient
      .post(prefix('adsPerformance/result/query'), {
        condition: {
          isFinished: params.condition.isFinished,
          quarter: params.condition.quarter,
          userOpenId: params.condition.userOpenId,
        },
        pageIndex: params.pageIndex,
        pageSize: params.pageSize,
      })
      .then((res) => {
        return {
          list:
            res.list?.map((item: AllMembersPerformanceItem) =>
              normalizePerformanceItem(item),
            ) || [],
          pageIndex: res.pageIndex,
          pageSize: res.pageSize,
          total: res.total,
        }
      })
  }

  /**
   * 修改考核系数
   * POST /gobestads/operation/adsPerformance/result/updateCoef
   */
  function updateAllMembersPerformanceCoef(
    params: AllMembersPerformanceUpdateCoefParams,
  ) {
    return requestClient.post(prefix('adsPerformance/result/updateCoef'), {
      finalCoef: params.finalCoef,
      id: params.id,
    })
  }

  return {
    getAllMembersPerformancePage,
    updateAllMembersPerformanceCoef,
  }
})
